import changeHashParams from "@utils/changeHashParams";
import {
    SEARCH_POSTS, SEARCH_SET_FILTER, LOADING,
} from "../actionTypes";

const initialState = {
    searchPostsData: {
        data: null,
        error: null,
    },
    getPostData: {
        data: null,
        error: null,
    },
    hash: null,
    isLoad: false,
};

const searchReducer = (state = initialState, {type, payload, isRemove}) => {
    switch (type) {
        case SEARCH_POSTS: {
            return {
                ...state,
                searchPostsData: {
                    data: payload,
                    error: null,
                },
                isLoad: false,
            };
        }
        case SEARCH_SET_FILTER: {
            let property = null;
            if (payload.split("=").length > 2) {
                property = payload.split("&");
            } else {
                property = payload.split("=")[0];
            }
            if (state.hash === null) {
                return {
                    ...state,
                    hash: `${payload}`,
                };
            }
            const hashState = changeHashParams({
                state, property, isRemove, payload,
            });
            if (hashState) return hashState;
            return {
                ...state,
                hash: isRemove ? payload : !state.hash ? payload : `${state.hash}&${payload}`,
            };
        }
        case LOADING: {
            return {
                ...state,
                isLoad: true,
            };
        }
        default:
            return state;
    }
};

export default searchReducer;
